"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _InterestPaymentsHeaderWithFilterComponent = _interopRequireDefault(require("./InterestPaymentsHeaderWithFilter/InterestPaymentsHeaderWithFilterComponent"));
var _InterestPaymentsTableWithFilter = _interopRequireDefault(require("./InterestPaymentsTableWithFilter"));
require("../RecentActivity/ActivityComponents.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var RecentActivityWithFilterComponent = function RecentActivityWithFilterComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('interest'),
    t = _useTranslation.t;
  var width = props.width,
    themeModifier = props.themeModifier,
    payments = props.payments;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement(_InterestPaymentsHeaderWithFilterComponent["default"], null), /*#__PURE__*/_react["default"].createElement(_InterestPaymentsTableWithFilter["default"], {
    payments: payments,
    themeModifier: themeModifier,
    width: width
  }));
};
var _default = exports["default"] = RecentActivityWithFilterComponent;